import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { CircularProgress } from '@material-ui/core';

/**
 * This receives a props with 2 elements (Categories and SeriesData)
 * @param {idCategories, SeriesData} props
 *
 */

const LineChartCore = props => {
	const { empresas, reports, users, isLoading } = props;
	const gastos = reports;

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	let xAxisCategories = [];
	let arrayEmpresasNuevas = [];
	let arrayGastos = [];
	let arrayGastosAprobados = [];
	let arrayGastosRechazados = [];
	let arrayReports = [];
	let arrayActiveUsers = [];
	let arrayRegUsers = [];
	let arrayEmpresasActivas = [];

	if (isLoading === false) {
		for (const element in empresas) {
			const monthYear = formatDate(empresas[element].initialDate);
			//let dateString = empresas[element].initialDate;
			//let split = dateString.split('-');
			//let date = split[0] + '-' + '0' + split[1] + '-01';

			xAxisCategories.push(monthYear);
			arrayEmpresasNuevas.push(empresas[element].nEmpresasNuevasActual);
		}

		for (const element in gastos) {
			arrayGastos.push(gastos[element].sumGastosActual);
			arrayGastosAprobados.push(gastos[element].sumGastosAprobadosActual);
			arrayGastosRechazados.push(gastos[element].sumGastosRechazadosActual);
		}

		for (const element in reports) {
			arrayReports.push(reports[element].nReportsActual);
		}

		for (const element in users) {
			arrayActiveUsers.push(users[element].nUsuariosActivosActual);
			arrayRegUsers.push(users[element].nUsuariosRegActual);
			arrayEmpresasActivas.push(users[element].nEmpresasActivasActual);
		}
	}

	const options = {
		chart: {
			type: 'line',
		},
		title: {
			text: 'Movimiento Data Core Negocio',
		},
		xAxis: {
			categories: xAxisCategories,
			//allowDecimals: false,
		},
		legend: {
			cursor: 'pointer',
			itemclick: function(e) {
				if (typeof e.dataSeries.visible === 'undefined' || e.dataSeries.visible) {
					e.dataSeries.visible = false;
				} else {
					e.dataSeries.visible = true;
				}
				e.chart.render();
			},
		},
		series: [
			{
				type: 'line',
				name: 'Empresas Nuevas',
				data: arrayEmpresasNuevas,
				color: 'green',
			},
			{
				type: 'line',
				name: 'Empresas Activas',
				data: arrayEmpresasActivas,
				color: 'lightblue',
			},
			{
				name: 'Gastos Aprobados',
				type: 'line',
				data: arrayGastosAprobados,
				color: 'blue',
			},
			{
				name: 'Gastos Rechazados',
				type: 'line',
				data: arrayGastosRechazados,
				color: 'red',
			},
			{
				name: 'Total Gastos',
				type: 'line',
				data: arrayGastos,
				color: 'blue',
			},
			{
				name: 'Reportes',
				type: 'line',
				data: arrayReports,
				color: 'lightblue',
			},
			{
				name: 'Usuarios Activos',
				type: 'line',
				data: arrayActiveUsers,
				color: 'orange',
			},
			{
				name: 'Usuarios Registrados',
				type: 'line',
				data: arrayRegUsers,
				color: 'yellow',
			},
		],
	};

	return <React.Fragment>{isLoading ? <CircularProgress /> : <HighchartsReact highcharts={Highcharts} options={options} />}</React.Fragment>;
};

export default React.memo(LineChartCore);
